var $31f966e58b99834b$exports = {};
$31f966e58b99834b$exports = {
  "pending": `beklemede`
};
export { $31f966e58b99834b$exports as default };